import React from 'react';
import { Pressable, HStack, Text, useTheme } from 'native-base';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { Platform } from 'react-native';
const GoBackButton = props => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const normalizeUrl = () => {
    if (window.location.hash) {
      let url = new URL(window.location.href);
      url.hash = '';
      window.history.pushState({
        path: url.toString()
      }, '', url.toString());
    }
  };
  const onPressHandler = () => {
    if (Platform.OS === 'web' && props.normalizeUrl) {
      normalizeUrl();
    }
    props.navigation.goBack();
  };
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => onPressHandler()
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faArrowLeft,
    color: colors.goBackButton.icon
  }), /*#__PURE__*/React.createElement(Text, {
    color: colors.goBackButton.text
  }, "Back")));
};
export default GoBackButton;
//# sourceMappingURL=GoBackButton.js.map